import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
import { getAPIErrorMessage } from 'api';
import { deleteDeviceInDeviceTree, filterDeviceTreeFromDuplicates, } from 'console/sortableDeviceTree/utils/device-tree-utils';
import { deviceTreeUpdateTime } from 'console/redux/devices/time';
import { selectDeviceTree } from 'console/redux/devices/tree/selectors';
import { selectDeviceTreeUpdateTime } from 'console/redux/devices/time/selectors';
export const setDevicesTreeStateFilter = (devices_tree_state_filter) => ({
    type: 'SET_DEVICES_TREE_STATE_FILTER',
    devices_tree_state_filter,
});
export const updateDeviceTreeFromServer = (device_tree, device_tree_update_time) => (dispatch, getState) => {
    const old_device_tree_update_time = selectDeviceTreeUpdateTime(getState());
    dispatch({
        type: 'UPDATE_DEVICE_TREE_FROM_SERVER',
        device_tree: filterDeviceTreeFromDuplicates(device_tree),
        device_tree_update_time,
        old_device_tree_update_time,
    });
};
export const addGroupInDeviceTree = (path, newTitle) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'ADD_GROUP_IN_DEVICE_TREE',
        path,
        newTitle,
    });
    dispatch(deviceTreeUpdateTime(device_tree_update_time));
    try {
        await api.update_device_tree(selectDeviceTree(getState()), device_tree_update_time);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось добавить группу'),
            error,
        }));
    }
};
export const deleteGroupInDeviceTree = (path) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'DELETE_GROUP_IN_DEVICE_TREE',
        path,
    });
    dispatch(deviceTreeUpdateTime(device_tree_update_time));
    try {
        await api.update_device_tree(selectDeviceTree(getState()), device_tree_update_time);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось удалить группу'),
            error,
        }));
    }
};
export const renameGroupInDeviceTree = (path, newTitle) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'RENAME_GROUP_IN_DEVICE_TREE',
        path,
        newTitle,
    });
    dispatch(deviceTreeUpdateTime(device_tree_update_time));
    try {
        await api.update_device_tree(selectDeviceTree(getState()), device_tree_update_time);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось переименовать группу'),
            error,
        }));
    }
};
export const addDeviceInGroupInDeviceTree = (path, device_id) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'ADD_DEVICE_IN_GROUP_IN_DEVICE_TREE',
        path,
        device_id,
    });
    dispatch(deviceTreeUpdateTime(device_tree_update_time));
    try {
        await api.update_device_tree(selectDeviceTree(getState()), device_tree_update_time);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось добавить устройство в группу'),
            error,
        }));
    }
};
export const expandGroupInDeviceTree = (path, expand) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'EXPAND_GROUP_IN_DEVICE_TREE',
        path,
        expand,
    });
    dispatch(deviceTreeUpdateTime(device_tree_update_time));
    await api.update_device_tree(selectDeviceTree(getState()), device_tree_update_time);
};
export const moveItemInDeviceTree = (old_path, new_path, new_tree_data) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'MOVE_ITEM_IN_DEVICE_TREE',
        new_path,
        old_path,
        new_tree_data,
    });
    dispatch(deviceTreeUpdateTime(device_tree_update_time));
    try {
        await api.update_device_tree(selectDeviceTree(getState()), device_tree_update_time);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось переместить элемент'),
            error,
        }));
    }
};
export const openAddDeviceInGroupDialog = (parentPath) => ({ type: 'ADD_DEVICE_IN_GROUP_OPEN', open: true, parentPath });
export const removeDeviceInDeviceTree = (device_id) => async (dispatch, getState, { api }) => {
    const device_tree_update_time = new Date().getTime();
    dispatch({
        type: 'REMOVE_DEVICE_IN_DEVICE_TREE',
        device_tree_update_time,
    });
    const exist_dev_tree = selectDeviceTree(getState());
    try {
        await api.update_device_tree(deleteDeviceInDeviceTree(exist_dev_tree, device_id), device_tree_update_time);
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Не удалось удалить устройство из группы'),
            error,
        }));
    }
};
